import type { Gender, PatientProfile } from "@/core/types";
import { patientRequestsTyped } from "@/api/(requests)/patientTyped";

export async function getPatientProfile(): Promise<PatientProfile> {
  const { user } = await patientRequestsTyped.fetch_profile({
    context: { showLoader: false },
  });

  return {
    ...user,
    // Normalise mixed-case API values ("Male"/"Female") to lowercase
    gender: (user.gender?.toLowerCase() ?? null) as Gender,
  };
}
